import React, { Component } from "react";

class Downloads extends Component {
  render() {
    return (
      <div className="downloads">
        <a
          className="app-store"
          href="https://itunes.apple.com/de/app/id385255956?mt=8&ign-mpt=uo%3D4"
        >
          Download aus dem App Store
        </a>
        <a
          className="play-store"
          href="https://play.google.com/store/apps/details?id=ch.swift.itheoriede&hl=en_GB"
        >
          Download aus dem Play Store
        </a>
        <a className="web-app" href="https://elearning.itheorie.de">
          Lernen im Web
        </a>
      </div>
    );
  }
}

export default Downloads;



// WEBPACK FOOTER //
// ./src/components/downloads.js